import React from "react";

const paths = {
  help: <><path d="M4 3h6a3 3 0 0 1 3 3v15a4 4 0 0 0-4-2H4zM13 6a3 3 0 0 1 3-3h5v16h-5a4 4 0 0 0-3 2M7 7h3M7 11h3M16 7h2M16 11h2"/></>,
  home: <><path d="m3 10 9-7 9 7"/><path d="M5 9v11h14V9M9 20v-7h6v7"/></>,
  document: <><path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8Z"/><path d="M14 3v5h5M9 12h6M9 16h6"/></>,
  upload: <><path d="M4 16v4h16v-4M12 16V3m-5 5 5-5 5 5"/></>,
  arrow: <><path d="M5 12h14m-5-5 5 5-5 5"/></>,
  back: <><path d="M19 12H5m5-5-5 5 5 5"/></>,
  check: <path d="m5 12 4 4L19 6"/>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
  return: <><path d="m8 4-5 5 5 5M3 9h11a6 6 0 0 1 0 12h-3"/></>,
  search: <><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></>,
  refresh: <><path d="M20 7v5h-5M4 17v-5h5"/><path d="M6 7a7 7 0 0 1 12-2l2 3M4 16l2 3a7 7 0 0 0 12-2"/></>,
  bus: <><rect x="5" y="3" width="14" height="16" rx="3"/><path d="M5 11h14M9 6h6M7 19v2m10-2v2M8 15h1m6 0h1"/></>,
  person: <><circle cx="12" cy="8" r="4"/><path d="M4 21v-2a8 8 0 0 1 16 0v2"/></>,
  building: <><path d="M4 21V3h12v18M16 9h4v12M2 21h20M8 7h4M8 11h4M8 15h4M9 21v-3h2v3"/></>,
  logout: <><path d="M9 4H4v16h5M14 8l4 4-4 4m-6-4h13"/></>,
  shield: <><path d="m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6Z"/><path d="m8 12 3 3 5-6"/></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 6 9 7 9-7"/></>,
  info: <><circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10v1"/></>,
  file: <><path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8Z"/><path d="M14 3v5h5"/></>,
  download: <><path d="M12 3v12m-5-5 5 5 5-5M4 17v4h16v-4"/></>,
  close: <path d="m6 6 12 12M6 18 18 6"/>,
  archive: <><path d="M4 9v12h16V9M3 3h18v6H3zM9 13h6"/></>,
  sheet: <><rect x="4" y="3" width="16" height="18" rx="1"/><path d="M4 8h16M4 13h16M4 17h16M10 8v13"/></>,
};

export function RepIcon({ name, size = 20, ...props }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>{paths[name] || paths.document}</svg>;
}

export function PageHeading({ eyebrow, title, description, action }) {
  return <div className="rep-page-heading">
    <div><div className="rep-eyebrow">{eyebrow || "Portal de proveedores"}</div><h1>{title}</h1>{description && <p>{description}</p>}</div>
    {action && <div className="rep-heading-action">{action}</div>}
  </div>;
}

export function Panel({ title, icon, subtitle, children, className = "", action }) {
  return <section className={`rep-panel ${className}`}>
    <div className="rep-panel-heading"><div className="rep-panel-title">{icon && <RepIcon name={icon}/>}<div><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div></div>{action}</div>
    <div className="rep-panel-body">{children}</div>
  </section>;
}

export function EmptyState({ title, children, icon = "document" }) {
  return <div className="rep-empty"><span className="rep-empty-icon"><RepIcon name={icon} size={26}/></span><h3>{title}</h3><p>{children}</p></div>;
}

export function AuthorizationProgress({ a }) {
  if (a.status === "ANULADA") return null;
  const step = { AUTORIZADA: 0, RECIBIDA: 1, DEVUELTA: 1, FACTURADA: 2, APROBADA: 3 }[a.status] ?? 0;
  const labels = ["Autorización", a.status === "DEVUELTA" ? "Corregir factura" : "Factura", "Revisión", "Aprobación"];
  return <ol className="rep-progress" aria-label="Progreso de la autorización">{labels.map((label, i) => <li key={i} className={i < step || a.status === "APROBADA" ? "done" : i === step ? "current" : ""} aria-current={i === step ? "step" : undefined}><span className="rep-progress-number">{i < step || a.status === "APROBADA" ? <RepIcon name="check" size={15}/> : i + 1}</span><span>{label}</span></li>)}</ol>;
}
